import { Component, input, output } from '@angular/core';
import { getAssetURL } from 'src/app/constants/assets';
import { GemstoneArrangement } from 'src/app/interfaces/gemstone-arrangement';
import { GemstoneArrangementWithSetting } from 'src/app/interfaces/gemstone-arrangement-with-setting';
import { GemstoneSize } from 'src/app/interfaces/gemstone-size';
import { GemstoneType } from 'src/app/interfaces/gemstone-type';
import { GemstoneTypeWithShape } from 'src/app/interfaces/gemstone-type-with-shape';
import { assert } from 'src/app/utils/assert.util';

@Component({
  selector: 'app-gemstone-card',
  templateUrl: './gemstone-card.component.html',
  styleUrl: './gemstone-card.component.scss'
})
export class GemstoneCardComponent<T extends ( GemstoneSize | GemstoneTypeWithShape | GemstoneArrangementWithSetting )> {
  isSelected = input(false);
  gemstoneAttributeValue = input<T>();
  gemstoneAttributeClick = output<T>();

  getThumbnail(attributeValue: T) {
    if (attributeValue?.thumbnail) {
      return getAssetURL(attributeValue.thumbnail);
    }
    return null;
  }

  cardClicked() {
    const value = this.gemstoneAttributeValue();
    assert(value, 'No gemstone attribute value');
    this.gemstoneAttributeClick.emit(value);
  }
}
